module.exports = {"name":"Presets","identifier":"presets","rights":[{"name":"bulk","identifier":"bulk"},{"name":"delete","identifier":"delete"},{"name":"edit","identifier":"edit"},{"name":"list","identifier":"list"},{"name":"view","identifier":"view"}]}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/users/data/modules/presets.json
// module id = 2421
// module chunks = 1